import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  UIActiveDialogService,
  UIDialogService
} from '../../shared/services/ui-dialog.service';
import { ConfirmationComponent } from '../components/confirmation/confirmation.component';
import { ConfirmationModel } from '../model/confirmation.model';

export interface ComponentCanDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class PendingChangesGuard
  implements CanDeactivate<ComponentCanDeactivate> {
  constructor(
    private dialogOpenService: UIDialogService,
    private dialogCloseService: UIActiveDialogService
  ) {}
  canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate()
      ? true
      : // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
        // when navigating away from your angular app, the browser will show a generic warning message
        this.dialogOpenService.open(ConfirmationComponent, [
          {
            provide: ConfirmationModel,
            useValue: new ConfirmationModel(
              'Are you sure you want to leave the page?',
              'Any unsaved data will be lost.'
            )
          }
        ]);
  }
}
